import { useFlags } from 'launchdarkly-react-client-sdk';
import PropTypes from 'prop-types';
import EverTrue from 'app';

const FEATURES = Object.freeze({
  cadences: 'Cadences',
  signal: 'Signal',
  aiSearch: 'AI Search',
  aiGeneral: 'AI General',
  cadenceV2Internal: 'Cadences 2.0',
});

const IsFlaggedController = ({ flag, flags, children, navigatePath }) => {
  const allFlags = useFlags();

  // Support either a single `flag` string or an ordered `flags` array (all must be enabled).
  // When both are provided, `flags` takes precedence.
  const flagsToCheck = flags || [flag];

  const loaded = flagsToCheck.every((f) => allFlags.hasOwnProperty(f));
  const firstFailingFlag = flagsToCheck.find((f) => !allFlags[f]);
  const enabled = !firstFailingFlag;

  if (loaded && !enabled && navigatePath) {
    EverTrue.Navigator(navigatePath, true);
    return null;
  }
  if (loaded && !enabled)
    return (
      <h1
        style={{
          textAlign: 'center',
          margin: 'auto',
          marginTop: '35vh',
          color: '#737373',
          lineHeight: 2,
        }}
        className="empty-state-message--text"
      >
        Your Organization does not have&nbsp;{FEATURES[firstFailingFlag] || 'this feature'}&nbsp;enabled.
        <br />
        Please contact your CSM to add&nbsp;{FEATURES[firstFailingFlag] || 'this feature'}&nbsp;to your organization.
      </h1>
    );
  if (enabled) return <>{children}</>;
  return null;
};

IsFlaggedController.propTypes = {
  flag: PropTypes.string,
  flags: PropTypes.arrayOf(PropTypes.string),
  children: PropTypes.node.isRequired,
  navigatePath: PropTypes.string,
};

export default IsFlaggedController;
